import api from "@/api";
import Coupon from "@/types/Coupon";
import { AxiosResponse } from "axios";

async function validateCoupons(
  codes: string[],
  reservation_id: string,
  event_id: string,
): Promise<AxiosResponse<Coupon[]>> {
  return await api.post<Coupon[]>(`/api/checkout/coupons`, {
    event_id,
    codes,
    reservation_id,
  });
}

export default validateCoupons;
